export default __webpack_public_path__ + "static/media/failed-screen-image.9c6fa73f.png";